<template>
  <div class="sort-container" :style="finalSortSetting.mainStyle">
    <div
      class="sort-item default-sort-item"
      v-if="showDefaultSort"
      :style="defaultBtnStyle"
      :class="[defaultIsActive ? 'active-sort-item' : '']"
      @click="setDefault"
      v-hover:sort-item-hover
    >
      <template v-if="defaultIsActive">
        <icon-set
          :icon="defaultBtnActiveSet"
          v-if="defaultBtnActiveSet && defaultBtnActiveSet.showIcon && defaultBtnActiveSet.iconPosition === 'left'"
        />
        <font-set :content="defaultSortLabel" :options="defaultBtnConfig.btnTextActive" key="activeFont"></font-set>
        <icon-set
          :icon="defaultBtnActiveSet"
          v-if="defaultBtnActiveSet && defaultBtnActiveSet.showIcon && defaultBtnActiveSet.iconPosition === 'right'"
        />
      </template>
      <template v-else>
        <icon-set
          class="default-icon"
          :icon="defaultBtnSet"
          :hoverIcon="defaultBtnHoverSet"
          v-if="defaultBtnSet && defaultBtnSet.showIcon && defaultBtnSet.iconPosition === 'left'"
        />
        <icon-set
          class="default-icon-hover"
          :icon="defaultBtnHoverSet"
          v-if="defaultBtnHoverSet && defaultBtnHoverSet.showIcon && defaultBtnHoverSet.iconPosition === 'left'"
        />
        <font-set 
          key="defaultFont"
          :content="defaultSortLabel" 
          :options="defaultBtnConfig.btnText"
          :hoverOptions="defaultBtnConfig.btnTextHover"></font-set>
        <icon-set
          class="default-icon"
          :icon="defaultBtnSet"
          :hoverIcon="defaultBtnHoverSet"
          v-if="defaultBtnSet && defaultBtnSet.showIcon && defaultBtnSet.iconPosition === 'right'"
        />
        <icon-set
          class="default-icon-hover"
          :icon="defaultBtnHoverSet"
          v-if="defaultBtnHoverSet && defaultBtnHoverSet.showIcon && defaultBtnHoverSet.iconPosition === 'right'"
        />
      </template>
    </div>
    <div
      class="sort-item real-sort-item"
      :class="[item.type && item.type !== 'default' ? 'active-sort-item' : '']"
      v-for="(item, index) in sortList"
      :key="index"
      :style="sortBtnStyle"
      @click="changeSortType(item.value)"
      v-hover:sort-item-hover
    >
      <template v-if="item.type === 'default'">
        <icon-set
          :icon="sortBtnIconSet"
          v-if="sortBtnIconSet && sortBtnIconSet.showIcon && sortBtnIconSet.iconPosition === 'left'"
        />
      </template>
      <template v-else>
        <icon-set
          :direction="item.type === 'asc' ? 'normal' : 'reverse'"
          :icon="sortBtnIconActiveSet"
          v-if="sortBtnIconActiveSet && sortBtnIconActiveSet.showIcon && sortBtnIconActiveSet.iconPosition === 'left'"
        />
      </template>
      <font-set :options="sortBtnConfig.btnText" class="default-text" :content="item.label" v-if="item.type === 'default'"></font-set>
      <font-set :options="sortBtnConfig.btnTextHover" class="default-text-hover" :content="item.label" v-if="item.type === 'default'"></font-set>
      <font-set :options="sortBtnConfig.btnTextActive" :content="item.label" v-if="item.type !== 'default'"></font-set>
      <template v-if="item.type === 'default'">
        <icon-set
          :icon="sortBtnIconSet"
          v-if="sortBtnIconSet && sortBtnIconSet.showIcon && sortBtnIconSet.iconPosition === 'right'"
        />
      </template>
      <template v-else>
        <icon-set
          :direction="item.type === 'asc' ? 'normal' : 'reverse'"
          :icon="sortBtnIconActiveSet"
          v-if="sortBtnIconActiveSet && sortBtnIconActiveSet.showIcon && sortBtnIconActiveSet.iconPosition === 'right'"
        />
      </template>
    </div>
  </div>
</template>
<script>
import "./v-hover"
import iconSet from "./icon-set.vue"
import fontSet from "./font-set.vue"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
import { getFinalConfigAndStyles } from "materials/navMenu/render/customSubMenus/setting/getFinalConfigAndStyles"
import { props as defaultBtnProps } from "../toolbars/anchorConfigs/defaultBtn/props"
import { props as mainProps } from "../toolbars/anchorConfigs/mainConfig/props"
import { props as sortBtnProps } from "../toolbars/anchorConfigs/sortItemBtn/props"
export default {
  name: "cxSort",
  components: {
    iconSet,
    fontSet
  },
  mixins: [subPageEventMixin],
  props: {
    options: {
      default: () => {},
      type: Object
    },
    myid: {
      type: Object,
      default: null
    }
  },
  computed: {
    finalSortSetting() {
      const { mainConfig = {}, defaultBtnConfig = {}, sortBtnConfig = {} } = this.options
      const [finalDefaultBtnConfig, finalDefaultBtnStyle] = getFinalConfigAndStyles(defaultBtnProps, defaultBtnConfig)
      const [finalSortBtnConfig, finalSortBtnStyle] = getFinalConfigAndStyles(sortBtnProps, sortBtnConfig)
      const [finalMainConfig, finalMainStyle] = getFinalConfigAndStyles(mainProps, mainConfig)
      if (finalDefaultBtnConfig.activeIsSameWithHover) {
        // 悬浮状态同选中状态， 悬浮状态样式也用选中状态的样式
        finalDefaultBtnConfig.btnTextHover = finalDefaultBtnConfig.btnTextActive
        finalDefaultBtnConfig.btnBackgroundHover = finalDefaultBtnConfig.btnBackgroundActive
        finalDefaultBtnConfig.btnBorderHover = finalDefaultBtnConfig.btnBorderActive
        finalDefaultBtnConfig.btnRadiusHover = finalDefaultBtnConfig.btnRadiusActive
        finalDefaultBtnConfig.btnOpacityHover = finalDefaultBtnConfig.btnOpacityActive
        finalDefaultBtnConfig.btnShadowHover = finalDefaultBtnConfig.btnShadowActive
        finalDefaultBtnConfig.btnIconHover = finalDefaultBtnConfig.btnIconActive
      }
      const [, mergedDefaultBtnStyle] = finalDefaultBtnConfig.activeIsSameWithHover
        ? getFinalConfigAndStyles(defaultBtnProps, defaultBtnConfig, finalDefaultBtnConfig)
        : [, finalDefaultBtnStyle]

      if (finalSortBtnConfig.activeIsSameWithHover) {
        // 悬浮状态同选中状态， 悬浮状态样式也用选中状态的样式
        finalSortBtnConfig.btnTextHover = finalSortBtnConfig.btnTextActive
        finalSortBtnConfig.btnBackgroundHover = finalSortBtnConfig.btnBackgroundActive
        finalSortBtnConfig.btnBorderHover = finalSortBtnConfig.btnBorderActive
        finalSortBtnConfig.btnRadiusHover = finalSortBtnConfig.btnRadiusActive
        finalSortBtnConfig.btnOpacityHover = finalSortBtnConfig.btnOpacityActive
        finalSortBtnConfig.btnShadowHover = finalSortBtnConfig.btnShadowActive
      }
      const [, mergedSortBtnStyle] = finalSortBtnConfig.activeIsSameWithHover
        ? getFinalConfigAndStyles(sortBtnProps, finalSortBtnConfig, finalSortBtnConfig)
        : [, finalSortBtnStyle]
      return {
        sortBtnConfig: finalSortBtnConfig,
        defaultBtnConfig: finalDefaultBtnConfig,
        mainConfig: finalMainConfig,
        sortBtnStyle: mergedSortBtnStyle,
        defaultBtnStyle: mergedDefaultBtnStyle,
        mainStyle: finalMainStyle,
        finalStyle: {
          "--page-theme-color": this.$store.state[this.request_prefix].page.themeColor
        }
      }
    },
    defaultBtnConfig() {
      return this.finalSortSetting?.defaultBtnConfig
    },
    sortBtnConfig() {
      return this.finalSortSetting?.sortBtnConfig
    },
    defaultBtnStyle() {
      return this.finalSortSetting?.defaultBtnStyle
    },
    sortBtnStyle() {
      return this.finalSortSetting?.sortBtnStyle
    },
    defaultBtnSet() {
      return this.defaultBtnConfig?.btnIcon
    },
    defaultBtnActiveSet() {
      return this.defaultBtnConfig?.btnIconActive
    },
    defaultBtnHoverSet() {
      return this.defaultBtnConfig?.btnIconHover
    },
    sortBtnIconSet() {
      return this.sortBtnConfig?.btnIcon
    },
    sortBtnIconHoverSet() {
      return this.sortBtnConfig?.btnIconHover
    },
    sortBtnIconActiveSet() {
      return this.sortBtnConfig?.btnIconActive
    },
    getSecondIconPosition() {
      return this.defaultBtnSet?.iconPosition
    },
    sortConfig() {
      return this.options.sortConfig || this.mockConfigData
    },
    showDefaultSort() {
      return this.finalSortSetting?.defaultBtnConfig?.showDefaultBtn
    },
    defaultSortLabel() {
      return this.sortConfig?.defaultSortLabel
    },
    sortList() {
      return this.options.sortItems || []
    },
    defaultIsActive() {
      return this.sortList.every(item => item.type === "default")
    },
    currentActiveSort() {
      if (this.defaultIsActive) {
        return "default"
      }
      return this.sortList.find(item => item.type && item.type !== "default")
    },
    listPageDataLayoutIds: {
      get() {
        return this.options.listPageDataLayoutIds
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "listPageDataLayoutIds", false, null, this.myid)
      }
    },
    isInLayoutSide() {
      return typeof this.myid?.directionIndex !== "undefined"
    },
    isListPage() {
      return this.$store.state[this.request_prefix].type === "listPage"
    }
  },
  data() {
    return {
      mockConfigData: {
        showDefaultSort: true,
        defaultSortLabel: "默认排序",
        sortList: [
          {
            label: "创建时间",
            value: "time",
            type: "default"
          },
          {
            label: "课程热度",
            value: "hot",
            type: "default"
          },
          {
            label: "学生数",
            value: "students",
            type: "default"
          },
          {
            label: "资源数",
            value: "resources",
            type: "default"
          }
        ]
      }
    }
  },
  watch: {
    currentActiveSort(newVal, oldVal) {
      oldVal && this.publishUpdate()
    }
  },
  mounted() {},
  methods: {
    setDefault() {
      this.sortList.forEach(item => {
        item.type = "default"
      })
    },
    initListPageSortData(plugin) {
      if (this.isInLayoutSide) return
      this.listPageDataLayoutIds = {
        container_id: plugin.containerId,
        rect_id: plugin.dataLayoutOptions?.rect_id
      }
    },
    getActiveSortItem() {
      if (this.defaultIsActive) {
        return "default"
      }
      return JSON.stringify([
        { name: this.currentActiveSort?.label, flag: this.currentActiveSort?.value, type: this.currentActiveSort?.type }
      ])
    },
    publishUpdate() {
      if (this.isInLayoutSide) {
        this.$eventBus.$emit(`update-layout-data-eventBus-${this.myid.container_id}-${this.myid.rect_id}`, {
          sortRule: this.getActiveSortItem()
        })
      } else if (this.isListPage && this.listPageDataLayoutIds?.rect_id) {
        this.$eventBus.$emit(
          `update-layout-data-eventBus-${this.listPageDataLayoutIds.container_id}-${this.listPageDataLayoutIds.rect_id}`,
          {
            sortRule: this.getActiveSortItem()
          }
        )
      }
    },
    changeSortType(typeValue) {
      this.sortList.forEach(item => {
        if (item.value === typeValue) {
          item.type = item.type === "default" ? "asc" : item.type === "asc" ? "desc" : "default"
        } else {
          item.type = "default"
        }
      })
      this.$emit("changeSortType", this.sortList)
    }
  }
}
</script>
<style lang="scss" scoped>
.sort-container {
  display: flex;
  flex-wrap: wrap;
  gap: var(--topDis) var(--leftDis);
  width: 100%;
  height: 100%;
  justify-content: var(--mainAlign);
  border-width: var(--mainBorder_borderWidth);
  border-color: var(--mainBorder_borderColor) !important;
  border-style: var(--mainBorder_borderStyle);
  background-repeat: var(--mainBackground_backgroundRepeat);
  background-image: var(--mainBackground_backgroundImage);
  background-color: var(--mainBackground_backgroundColor);
  background-size: var(--mainBackground_backgroundSize);
  background-position: var(--mainBackground_backgroundPosition);
  border-radius: var(--mainRadius);
  opacity: var(--mainOpacity);
  box-shadow: var(--mainShadow);
  padding: var(--mainPadding);
  .sort-item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    .sort-icon {
      margin-left: 5px;
      color: #000;
      &.is-active {
        color: #1890ff;
      }
    }
    &.active-sort-item {
      color: #1890ff;
    }
    .sort-types {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 5px;
    }
  }
}
.real-sort-item,
.default-sort-item {
  width: var(--btnSize_width);
  height: var(--btnSize_height);
  border-width: var(--btnBorder_borderWidth);
  border-color: var(--btnBorder_borderColor) !important;
  border-style: var(--btnBorder_borderStyle);
  background-repeat: var(--btnBackground_backgroundRepeat);
  background-image: var(--btnBackground_backgroundImage);
  background-color: var(--btnBackground_backgroundColor);
  background-size: var(--btnBackground_backgroundSize);
  background-position: var(--btnBackground_backgroundPosition);
  border-radius: var(--btnRadius);
  opacity: var(--btnOpacity);
  box-shadow: var(--btnShadow);
  padding: var(--btnPadding);
  &:hover {
    border-width: var(--btnBorderHover_borderWidth);
    border-color: var(--btnBorderHover_borderColor) !important;
    border-style: var(--btnBorderHover_borderStyle);
    background-repeat: var(--btnBackgroundHover_backgroundRepeat);
    background-image: var(--btnBackgroundHover_backgroundImage);
    background-color: var(--btnBackgroundHover_backgroundColor);
    background-size: var(--btnBackgroundHover_backgroundSize);
    background-position: var(--btnBackgroundHover_backgroundPosition);
    border-radius: var(--btnRadiusHover);
    opacity: var(--btnOpacityHover);
    box-shadow: var(--btnShadowHover);
    padding: var(--btnPadding);
  }
  &.active-sort-item {
    border-width: var(--btnBorderActive_borderWidth);
    border-color: var(--btnBorderActive_borderColor) !important;
    border-style: var(--btnBorderActive_borderStyle);
    background-repeat: var(--btnBackgroundActive_backgroundRepeat);
    background-image: var(--btnBackgroundActive_backgroundImage);
    background-color: var(--btnBackgroundActive_backgroundColor);
    background-size: var(--btnBackgroundActive_backgroundSize);
    background-position: var(--btnBackgroundActive_backgroundPosition);
    border-radius: var(--btnRadiusActive);
    opacity: var(--btnOpacityActive);
    box-shadow: var(--btnShadowActive);
    padding: var(--btnPadding);
  }
  
}
.real-sort-item, .default-sort-item {
  .default-icon-hover {
    display: none;
  }
  .default-icon {
    display: unset;
  }
  .default-text-hover {
    display: none !important;
  }
  .default-text {
    display: inline-block !important;
  }
}
.real-sort-item.sort-item-hover,  .default-sort-item.sort-item-hover {
  .default-icon {
    display: none;
  }
  .default-icon-hover {
    display: unset;
  }
  .default-text-hover {
    display: inline-block !important;
  }
  .default-text {
    display: none !important;
  }
}
</style>
